"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _phaser = _interopRequireDefault(require("phaser"));

var _Dna = _interopRequireDefault(require("../sprites/Dna"));

var _ActionZone = _interopRequireDefault(require("../sprites/ActionZone"));

var _app = require("../app");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var timer;

var Game =
/*#__PURE__*/
function (_Phaser$State) {
  _inherits(Game, _Phaser$State);

  function Game() {
    _classCallCheck(this, Game);

    return _possibleConstructorReturn(this, _getPrototypeOf(Game).apply(this, arguments));
  }

  _createClass(Game, [{
    key: "init",
    value: function init() {
      this.game.stage.backgroundColor = '#19233E';
      this.alive_dnas = [];
    }
  }, {
    key: "create",
    value: function create() {
      this.world_collision = this.game.physics.p2.createCollisionGroup();
      this.game.physics.p2.updateBoundsCollisionGroup(this.world_collision);
      this.action_collision = this.game.physics.p2.createCollisionGroup();
      this.action_exit_collision = this.game.physics.p2.createCollisionGroup();
      this.dna_collision = this.game.physics.p2.createCollisionGroup();
      this.down_speed = 100;
      this.game.time.desiredFps = 10;
      this.game.raf.forceSetTimeout = false;
      this.game.forceSingleUpdate = false;
      this.game.forceSingleRender = false;
      this.action_zone = new _ActionZone.default(this.game, 0, 608);
      var dna;
      this.dnas = [];
      var total_dna = 150;
      var show_at_start = total_dna - 12;

      for (var i = 0; i < total_dna; i++) {
        if (i < show_at_start) {
          this.dnas.push(new _Dna.default(this.game, 100, 10, i, false));
        } else {
          this.dnas.push(new _Dna.default(this.game, 100, 768 - (50 + (i - show_at_start) * 61), i, true));
        }
      }

      this.header = this.game.add.image(0, 0, 'header');
      this.header.width = 1024;
      this.header.height = 48;
      this.sidebar = this.game.add.image(674, 0, 'sidebar');
      this.sidebar.width = 352;
      this.sidebar.height = 768;
      this.reset_button = this.game.add.button(929, 17, 'exit', this.resetGame, this, 0, 0, 0);
      this.reset_button.input.useHandCursor = true;
      this.reset_button.width = 83;
      this.reset_button.height = 30;
      this.add_button = this.game.add.button(762, 524, 'methylate', this.addMeth, this, 0, 0, 1);
      this.remove_button = this.game.add.button(762, 617, 'demethylate', this.removeMeth, this, 0, 0, 1);
      this.age_group = this.game.add.group();
      this.game.age = 0;
      this.game.score = 100;
      this.sound_score_up = this.game.add.audio('score_up');
      this.sound_score_down = this.game.add.audio('score_down');
      $(".js-timer").show();
      this.updateAge();
    }
  }, {
    key: "update",
    value: function update() {
      var down_speed = this.down_speed;
      this.alive_dnas.forEach(function (dna) {
        return dna.body.moveDown(down_speed);
      });
    }
  }, {
    key: "updateAge",
    value: function updateAge() {
      $(".js-timer").text(this.game.age);
      timer = setTimeout(function () {
        if (this.game.age < 100) {
          this.game.age++;
          this.updateAge();
          this.down_speed += 2;
        } else {
          this.gameOver();
        }
      }.bind(this), 1000);
    }
  }, {
    key: "gameOver",
    value: function gameOver() {
      $(".js-timer").hide();
      (0, _app.gameOver)(this.game.score);
      this.game.state.start('Boot');
    }
  }, {
    key: "resetGame",
    value: function resetGame() {
      clearTimeout(timer);
      this.game.state.start('Boot');
      $(".js-screen").removeClass('active');
      $(".js-intro.js-screen").addClass('active');
    }
  }, {
    key: "addMeth",
    value: function addMeth() {
      if (this.game.dna != null) {
        this.validateHit(1);
      }
    }
  }, {
    key: "removeMeth",
    value: function removeMeth() {
      if (this.game.dna != null) {
        this.validateHit(-1);
      }
    }
  }, {
    key: "validateHit",
    value: function validateHit(direction) {
      if (this.game.dna != null) {
        this.game.dna.validateHit(direction);
        this.game.dna = null;
      }
    }
  }]);

  return Game;
}(_phaser.default.State);

exports.default = Game;